import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api, { getApiErrorMessage } from '../api';

// Отписка по ссылке из письма. Подтверждение кнопкой: почтовые сервисы сами открывают ссылки из писем
// при проверке на вирусы, и автоматическая отписка при открытии страницы срабатывала бы без ведома человека.
function Unsubscribe() {
    const [params] = useSearchParams();
    const token = params.get('t') || '';
    const fromLetter = params.get('r') || undefined; // письмо рассылки — для статистики отписок
    const [state, setState] = useState('idle');
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const unsubscribe = async () => {
        setState('loading');
        setError('');
        try {
            const res = await api.post('/newsletter/unsubscribe', { token, r: fromLetter });
            setEmail(res.data.email || '');
            setState('done');
        } catch (err) {
            setError(getApiErrorMessage(err, 'Не удалось отписаться. Попробуйте позже или отключите рассылку в профиле.'));
            setState('idle');
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h2 style={styles.title}>Рассылка СВОД</h2>
                {state === 'done' ? (
                    <>
                        <p style={styles.text}>
                            Готово: {email ? <b>{email}</b> : 'ваш адрес'} больше не будет получать информационные и рекламные письма.
                            Письма о безопасности аккаунта и отчёты по опросам продолжат приходить.
                        </p>
                        {/* Участник опроса (токен c…) кабинета не имеет */}
                        {!token.startsWith('c') && <p style={styles.muted}>Передумаете — включите рассылку в профиле.</p>}
                    </>
                ) : !token ? (
                    <p style={styles.text}>Ссылка неполная. Отключить рассылку можно в <Link to="/profile">профиле</Link>.</p>
                ) : (
                    <>
                        <p style={styles.text}>Отписаться от информационной рассылки СВОД: писем с новостями, скидками и промокодами?</p>
                        {error && <p style={styles.error} role="alert">{error}</p>}
                        <button type="button" className="btn btn--primary" style={{ width: '100%' }} onClick={unsubscribe} disabled={state === 'loading'}>
                            {state === 'loading' ? 'Отписываем…' : 'Отписаться'}
                        </button>
                    </>
                )}
                <p style={styles.muted}><Link to="/">На главную</Link></p>
            </div>
        </div>
    );
}

const styles = {
    container: { display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: '16px', backgroundColor: '#f5f7fa', boxSizing: 'border-box' },
    card: { padding: '32px', backgroundColor: '#fff', borderRadius: '16px', boxShadow: '0 10px 25px rgba(0,0,0,0.05)', maxWidth: '440px', width: '100%', textAlign: 'center', boxSizing: 'border-box' },
    title: { margin: '0 0 16px', color: '#2d3748', fontSize: '22px' },
    text: { color: '#4a5568', lineHeight: 1.5, margin: '0 0 20px' },
    muted: { color: '#718096', fontSize: '14px', margin: '16px 0 0' },
    error: { color: '#c53030', margin: '0 0 12px' },
};

export default Unsubscribe;
